import React, { useCallback, useMemo } from "react";
import BootstrapModal from "components/PopUps/BootstrapModal";
import SecretVideoPurchase from "components/PracticeMaterial/PopUps/SecretVideoPurchase";
import { useNavigate } from "react-router-dom";

const ExplanationVidPopUp = React.memo(({ status, toggle, expVid }) => {

  const navigate = useNavigate();

  const closeVideoModel = useCallback(() => {
    toggle(false);
  }, [toggle]);

  const video = useMemo(() => {
    if (!expVid) return null;

    return (
      <iframe
        src={expVid}
        width="90%"
        height="100%"
        style={{ border: "none" }}
        title="Explanation video"
      />
    );
  }, [expVid]);

  const goToPayment = useCallback(() => {
    navigate("/admin/sub/payment/form/37");
  }, [navigate]);

  return (
    <>
      <BootstrapModal
        status={status && !!expVid}
        toggle={closeVideoModel}
        message=""
        data={video}
        width={{ width: "61%" }}
      />

      <SecretVideoPurchase
        isOpen={status && !expVid}
        toggle={closeVideoModel}
        handleClick={goToPayment}
      />
    </>
  );
});

export default ExplanationVidPopUp;